import {
  ALL_COURSE_MEMBERSHIP_TYPES as SharedALL_COURSE_MEMBERSHIP_TYPES,
  ALL_COURSE_OWNERSHIP_TYPES as SharedALL_COURSE_OWNERSHIP_TYPES,
  ALL_COURSE_TEE_STATUSES as SharedALL_COURSE_TEE_STATUSES,
  COURSE_MEMBERSHIP_TYPES as SharedCOURSE_MEMBERSHIP_TYPES,
  COURSE_OWNERSHIP_TYPES as SharedCOURSE_OWNERSHIP_TYPES,
  COURSE_TEE_STATUSES as SharedCOURSE_TEE_STATUSES,
  USGA_COURSE_IMPORT_STATUSES as SharedUSGA_COURSE_IMPORT_STATUSES,
} from "shared/dist/types/Course";

import type { Course as SharedCourse } from "shared/dist/types/Course";
import type { CoursePair as SharedCoursePair } from "shared/dist/types/CoursePair";

export type {
  UsgaGhinSeason,
  CourseMembershipType,
  CourseTee,
  CourseTeeSnapshot,
  CourseTeeStatus,
  CourseOwnershipType,
  ScorecardImage,
  UsgaCourseImport,
  UsgaCourseImportStatus,
} from "shared/dist/types/Course";

export const ALL_COURSE_MEMBERSHIP_TYPES = SharedALL_COURSE_MEMBERSHIP_TYPES;
export const ALL_COURSE_OWNERSHIP_TYPES = SharedALL_COURSE_OWNERSHIP_TYPES;
export const ALL_COURSE_TEE_STATUSES = SharedALL_COURSE_TEE_STATUSES;
export const COURSE_MEMBERSHIP_TYPES = SharedCOURSE_MEMBERSHIP_TYPES;
export const COURSE_OWNERSHIP_TYPES = SharedCOURSE_OWNERSHIP_TYPES;
export const COURSE_TEE_STATUSES = SharedCOURSE_TEE_STATUSES;
export const USGA_COURSE_IMPORT_STATUSES = SharedUSGA_COURSE_IMPORT_STATUSES;

export default interface Course extends SharedCourse {}
export interface CoursePair extends SharedCoursePair {}
